module.exports = __webpack_public_path__ + "static/media/notFound.0f27edbe.jpeg";